import React from 'react'
import styles from '../../styles/common/ProgressStep.module.scss'

interface ProgressPercentProps {
  percent: number // 0~100
}

const ProgressPercent: React.FC<ProgressPercentProps> = ({ percent }) => {
  const safePercent = Math.min(Math.max(percent, 0), 100)

  return (
    <div className={styles.progressContainer}>
      <div className={styles.progressWrapper}>
        {/* 배경 라인 */}
        <div className={styles.progressLineBg} />
        {/* 진행된 라인 */}
        <div
          className={styles.progressLineActive}
          style={{ width: `${safePercent}%` }}
        />

        {/* 왕관 아이콘 */}
        <div
          className={styles.progressNode}
          style={{ left: `${safePercent}%` }}
        >
          <div className={`${styles.nodeCircle} ${styles.current}`}>
            <img
              src="/assets/crown.png"
              className={styles.crownIcon}
              alt="Crown"
            />
          </div>
        </div>
      </div>

      {/* 퍼센트 텍스트 라벨 */}
      <div className={styles.labelsWrapper}>
        <div
          className={styles.progressLabel}
          style={{ left: `${safePercent}%` }}
        >
          <div className={`${styles.labelText} ${styles.active}`}>
            {safePercent}%
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProgressPercent
